import { apiFetch } from "./http";

// analyzeDocuments — yüklenen dokümanlar + prompt ile AI analiz sonucu (Markdown).
// FormData alanları: prompt, main (tek dosya), refs (çok dosya).
export async function analyzeDocuments(fd: FormData): Promise<{ result: string }> {
  const res = await apiFetch("/api/v1/ai/doc-analysis", { method: "POST", body: fd });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

// editDocuments — analiz sonucuna göre GSPR'yi düzeltir (500 kredi).
// FormData: analysis (bulgular), prompt (ops), main (dosya) veya main_doc_id (seçili doküman).
export async function editDocuments(fd: FormData): Promise<{ result: string }> {
  const res = await apiFetch("/api/v1/ai/doc-edit", { method: "POST", body: fd });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

// analysisDocxBlob — analiz sonucunu .docx olarak indirir (blob döner).
export async function analysisDocxBlob(title: string, content: string): Promise<Blob> {
  const res = await apiFetch("/api/v1/ai/doc-analysis/docx", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, content }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.blob();
}
